var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a", { attrs: { href: "#" + _vm.link } }, [
    _c("img", {
      style: _vm.cssStyle,
      attrs: { src: _vm._.imgPath(_vm.initialValue, _vm.variant) }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a9cb1de", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a9cb1de","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/table-elements/ThumbnailComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3a9cb1de","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/table-elements/ThumbnailComponent.vue
// module chunks = 0